import { FC } from "react";
import { Search } from "@/models/search/Search";
import { SearchTag } from "@/components/data-table/search-tag";
import { formatSearchDisplayLabel } from "../lib/formatSearchDisplayLabel";

interface SearchDisplayLabelProps {
  search: Search;
  className?: string;
}

/**
 * Compact search summary matching RecentSearchCard / global search list styling.
 */
const SearchDisplayLabel: FC<SearchDisplayLabelProps> = ({
  search,
  className = "",
}) => {
  const term = search.searchTerm?.trim() ?? "";
  const tags = (search.searchTags ?? []).map((tag) => tag.trim()).filter(Boolean);
  const hasContent = tags.length > 0 || term.length > 0;

  if (!hasContent) {
    return (
      <span className={`text-sm text-muted-foreground italic ${className}`}>
        Søgning uden søgeterm
      </span>
    );
  }

  return (
    <div
      className={`flex min-w-0 flex-wrap items-center gap-1 ${className}`}
      title={formatSearchDisplayLabel(search)}
    >
      {tags.map((tag, index) => (
        <SearchTag key={`${tag}-${index}`} tag={tag} variant="inline" />
      ))}
      {term && (
        <span className="truncate text-sm font-medium" title={term}>
          {term}
        </span>
      )}
    </div>
  );
};

export default SearchDisplayLabel;
